import { render } from "./ColorExclusions.vue?vue&type=template&id=50106b1d"
import script from "./ColorExclusions.vue?vue&type=script&lang=js"
export * from "./ColorExclusions.vue?vue&type=script&lang=js"

import "./ColorExclusions.vue?vue&type=style&index=0&id=50106b1d&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__